<template>
  <span class="tag is-info has-text-weight-bold heading">{{ $t("res.live") }}</span>
</template>

<script>
  export default {
    name: 'live-tag'
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/LiveTag.vue